import { useTranslation } from 'react-i18next';

import { useListArticlesQuery } from '@/services/newsApi';
import { useAppSelector } from '@/store/hooks';
import { ArticleCard } from '@/components/news/ArticleCard';
import { GameHeader } from '@/components/games/GameHeader';
import { Loader } from '@/components/common/Loader';

export function News() {
  const { t, i18n } = useTranslation('news');
  const locale = useAppSelector((s) => s.news.locale) || i18n.language || 'en';

  const { data, isLoading, isError } = useListArticlesQuery({ locale, limit: 30 });

  return (
    <div className="flex flex-col gap-4 px-4 pb-6 pt-5">
      <header>
        <h1 className="text-2xl font-bold text-fg">{t('title', { defaultValue: 'News' })}</h1>
        <p className="mt-1 text-sm text-fg-muted">
          {t('subtitle', { defaultValue: 'Latest from QLASH and the esports scene' })}
        </p>
      </header>

      <GameHeader />

      {isLoading && (
        <div className="flex h-40 items-center justify-center">
          <Loader />
        </div>
      )}

      {isError && (
        <div className="rounded-xl bg-bg-secondary p-6 text-center text-sm text-danger">
          {t('load_error', { defaultValue: 'Failed to load articles.' })}
        </div>
      )}

      {!isLoading && !isError && !data?.docs?.length && (
        <div className="rounded-xl bg-bg-secondary p-6 text-center text-sm text-fg-muted">
          {t('empty', { defaultValue: 'No articles yet. Check back soon!' })}
        </div>
      )}

      <ul className="flex flex-col gap-3">
        {data?.docs?.map((article) => (
          <li key={article._id}>
            <ArticleCard article={article} locale={locale} />
          </li>
        ))}
      </ul>
    </div>
  );
}
